// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

export const CHECKBOX_TESTID = 'software-backlog.card-list.card.card-contents.checkbox';
export const CARD_CONTAINER_TESTID = 'software-backlog.card-list.card.card-contents.card-container';
export const CARDS_AMOUNT_BADGE_TESTID =
	'software-backlog.card-list.card.card-contents.cards-amount-badge';

export const CMD_CLICK_ANALYTICS_ID = 'cmdclick';
export const CHECKBOX_ANALYTICS_ID = 'checkbox';
export const SHIFT_CLICK_ANALYTICS_ID = 'shiftclick';
export const CMD_SHIFT_CLICK_ANALYTICS_ID = 'cmdshiftclick';

export const CHECKBOX_COMPONENT_SELECTOR = 'software-backlog-card-card-contents-checkbox-container';
export const KEY_COMPONENT_SELECTOR = 'software-backlog.card-list.card.card-contents.key';

export const KEY_CONTAINER_TEST_ID =
	'software-backlog.card-list.card.card-contents.accessible-card-key';
export const SCREEN_READER_KEY_TEST_ID =
	'software-backlog.card-list.card.card-contents.screen-reader-key';
export const FLAG_CONTAINER_TEST_ID =
	'software-backlog.card-list.card.card-contents.flag-container';
export const FLAGGED_BUTTON_TEST_ID =
	'software-backlog.card-list.card.card-contents.flagged-button';
export const ADD_FLAG_BUTTON_TEST_ID =
	'software-backlog.card-list.card.card-contents.add-flag-button';
export const ESTIMATE_FIELD_WRAPPER_TEST_ID =
	'software-backlog.card-list.card.card-contents.estimate-field-wrapper';
export const SUMMARY_TEST_ID = 'software-backlog.card-list.card.card-contents.summary';

export const IMAGE_SIZE = gridSize * 2;
